import { Button, Dialog, DialogBody, DialogContent, DialogSurface, DialogTitle, DialogTrigger, Dropdown, Field, Input, Option } from '@fluentui/react-components';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '../../common/PageHeader';
import { LoadingState } from '../../common/LoadingState';
import { ErrorState } from '../../common/ErrorState';
import { EmptyState } from '../../common/EmptyState';
import { StatusBadge } from '../../common/StatusBadge';
import { DataTable } from '../../common/DataTable';
import { useClients } from '../../../hooks/useClients';
import { ClientStatus } from '../../../models/enums';
import { formatDateTime } from '../../../utils/date';
import { ClientForm } from './ClientForm';

export const ClientsListPage = () => {
  const navigate = useNavigate();
  const { clients, loading, error, filters, setFilters, reload, createClient } = useClients();

  if (loading && clients.length === 0) return <LoadingState label="Loading clients..." />;
  if (error) return <ErrorState message={error} onRetry={() => void reload()} />;

  return (
    <div>
      <PageHeader title="Clients" subtitle="Customer master data and Partner Center sync status" />
      <div style={{ display: 'flex', gap: 12, marginBottom: 16, alignItems: 'end' }}>
        <Field label="Search"><Input value={filters.search} onChange={(_, data) => setFilters((current) => ({ ...current, search: data.value }))} /></Field>
        <Field label="Status">
          <Dropdown selectedOptions={[String(filters.status)]} value={filters.status === 'all' ? 'All statuses' : undefined} onOptionSelect={(_, data) => setFilters((current) => ({ ...current, status: data.optionValue === 'all' ? 'all' : Number(data.optionValue) as ClientStatus }))}>
            <Option value="all">All statuses</Option>
            <Option value={String(ClientStatus.Actif)}>Active</Option>
            <Option value={String(ClientStatus.Suspendu)}>Suspended</Option>
            <Option value={String(ClientStatus.Inactif)}>Inactive</Option>
            <Option value={String(ClientStatus.EnPeriodeTrial)}>Trial</Option>
          </Dropdown>
        </Field>
        <Dialog>
          <DialogTrigger disableButtonEnhancement><Button appearance="primary">New client</Button></DialogTrigger>
          <DialogSurface><DialogBody><DialogTitle>Create client</DialogTitle><DialogContent><ClientForm onSubmit={(payload) => void createClient(payload)} /></DialogContent></DialogBody></DialogSurface>
        </Dialog>
      </div>
      {clients.length === 0
        ? <EmptyState title="No client yet" description="Create your first customer account to start." />
        : <DataTable
            items={clients}
            columns={[
              { columnId: 'name', label: 'Company', renderCell: (item) => item.cr_crm_companyname, compare: (a, b) => a.cr_crm_companyname.localeCompare(b.cr_crm_companyname) },
              { columnId: 'domain', label: 'Domain', renderCell: (item) => item.cr_crm_domain ?? '—' },
              { columnId: 'email', label: 'Email', renderCell: (item) => item.cr_crm_email ?? '—' },
              { columnId: 'status', label: 'Status', renderCell: (item) => <StatusBadge value={item.cr_crm_status} /> },
              { columnId: 'sync', label: 'Last sync', renderCell: (item) => formatDateTime(item.cr_crm_lastsyncat) },
            ]}
            getRowId={(item) => item.cr_crm_clientid}
            onRowClick={(item) => navigate(`/clients/${item.cr_crm_clientid}`)}
          />
      }
    </div>
  );
};
